/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export enum CrudEvent {
  UPDATE,
  SORT,
  DELETE_PICTURE,
  UPDATE_PICTURE,
  UPLOADING,
  UPLOADING_DONE,
  WIDGET_CLOSE,
}
